   document.addEventListener('DOMContentLoaded', function() {
    // Select all elements with the class 'swiper-wrapper'
    var swiperWrappers = document.querySelectorAll('.swiper-wrapper');
    var swiperSlides = document.querySelectorAll('.hero-carousel-swiper .swiper-slide');
    
    // Remove the 'aria-live' attribute from swiper wrappers
    swiperWrappers.forEach(function(wrapper) {
        wrapper.removeAttribute('aria-live');
    });
  
    swiperSlides.forEach(function(slide) {
        // Remove existing 'aria-label' and 'role' attributes
        slide.removeAttribute('aria-label');
        slide.removeAttribute('role');
  
        // Get the index from the data-swiper-slide-index attribute
        var index = parseInt(slide.getAttribute('data-swiper-slide-index')) + 1;
        
        // Dynamically get content specific to this slide
        var preheading = slide.querySelector('.pre_heading-main') ? slide.querySelector('.pre_heading-main').textContent.trim() : '';
        var mainheading = slide.querySelector('.heading') ? slide.querySelector('.heading').textContent.trim() : '';
        var maincaption = slide.querySelector('.subheading') ? slide.querySelector('.subheading').textContent.trim() : '';
        var precaption = slide.querySelector('.description') ? slide.querySelector('.description').textContent.trim() : '';
  
        // Construct the aria-label with the specific content for this slide
        var ariaLabel = `Slide number: ${index} - | ${preheading} - ${mainheading} - ${maincaption} - ${precaption}`;
  
        // Select the child element where you want to add the aria-label
        var slideContent = slide.querySelector('.hero-carousel-content');
        
        // Set the aria-label with the constructed value if slideContent exists
        if (slideContent) {
            slideContent.setAttribute('aria-label', ariaLabel);
        }
    });
  });
  
  
  document.addEventListener('DOMContentLoaded', function() {
    // Select all elements with the class 'hero-image-main'
    var imageSections = document.querySelectorAll('.hero-image-main');
  
    imageSections.forEach(function(hero) {
        // Retrieve content specific to each section
        var preheading = hero.querySelector('.pre_heading-main') ? hero.querySelector('.pre_heading-main').textContent.trim() : '';
        var mainheading = hero.querySelector('.heading') ? hero.querySelector('.heading').textContent.trim() : '';
        var maincaption = hero.querySelector('.subheading') ? hero.querySelector('.subheading').textContent.trim() : '';
        var precaption = hero.querySelector('.description') ? hero.querySelector('.description').textContent.trim() : '';
        
        // Construct the aria-label
        var ariaLabel = `Section content: ${preheading} - ${mainheading} - ${maincaption} - ${precaption}`;
        
        // Select the .hero-carousel-content-content div within the current hero section
        var contentDiv = hero.querySelector('.hero-carousel-content .hero-carousel-content-inner');
        
        // Set the aria-label with the constructed value if contentDiv exists
        if (contentDiv) {
            contentDiv.setAttribute('aria-label', ariaLabel);
        }
  
    });
  }); 
  document.addEventListener('DOMContentLoaded', function() { 
    var herobanner = document.querySelectorAll('.hero-banner-section');
    herobanner.forEach(function(hero) {
      var bannercontent = hero.querySelector('.hero-carousel-content-content')
      var haselement = bannercontent.querySelector('a, button, input, [tabindex]');
      var bannerinner = hero.querySelector('.hero-carousel-content');
      if (!haselement) {
         bannerinner.removeAttribute('tabindex');     
      }
      
    })
  })
  
  document.addEventListener('DOMContentLoaded', function() { 
    var stickbanner = document.querySelectorAll('.content-wrapper-outer');
    stickbanner.forEach(function(banner) {
      
      var hasInteractiveElement = banner.querySelector('a, button, input, [tabindex]');
       
      if (hasInteractiveElement) {
        var bannerTitle = banner.querySelector('.heading-wrapper .heading')?.textContent || '';
        var secondTitle = banner.querySelector('.subheading')?.textContent || '';
  
        // Set aria-label attribute if interactive elements are found
        banner.setAttribute('aria-label', `Title is ${bannerTitle}, subtitle is ${secondTitle}`);
      } else {
        // Remove tabindex and aria-label if no interactive elements are found
        banner.removeAttribute('tabindex');
        banner.removeAttribute('aria-label');
      }
      });
    
    var swatchlist = document.querySelectorAll('.card_product-swatches');
    var swatchlistpdp = document.querySelectorAll('.meta-product-swatches');
    swatchlist.forEach(function(swatch) {
      var hasInteractiveElement = swatch.querySelector('a, button, input, [tabindex]');
      if (!hasInteractiveElement) {
        swatch.removeAttribute('tabindex');
        swatch.removeAttribute('aria-label');
      }
    })
    swatchlistpdp.forEach(function(swatchpdp) {
      var hasInteractiveElement = swatchpdp.querySelector('a, button, input, [tabindex]');
      if (!hasInteractiveElement) {
        swatchpdp.removeAttribute('tabindex');
        swatchpdp.removeAttribute('aria-label');
      }
    })
  })
  
     document.addEventListener('DOMContentLoaded', function() {
      var title = document.querySelector('.modular-section-wrapepr .item-header .heading-wrapper .heading')?.textContent;
      var caption = document.querySelector('.modular-section-wrapepr .item-header .description p')?.textContent;
      var contentdiv = document.querySelector('.modular-section-wrapepr .item-header .header-text');
      contentdiv?.setAttribute('aria-label' ,`Title : ${title} , description : ${caption}`);
     })
  
  
     document.addEventListener('DOMContentLoaded', function() { 
      var banners = document.querySelectorAll('.banner-box');
      
      banners.forEach(function(banner) {
        var hasInteractiveElement = banner.querySelector('a, button, input, [tabindex]');
        
        // if (hasInteractiveElement) {
          var bannerTitle = banner.querySelector('.heading-wrapper .heading')?.textContent || '';
          var secondTitle = banner.querySelector('.subheading')?.textContent || '';
          var bannerText = banner.querySelector('.description p')?.textContent || '';
    
          // Build aria-label dynamically
          var ariaLabelParts = [];
    
          if (bannerTitle) {
            ariaLabelParts.push(`Title is ${bannerTitle}`);
          }
          if (secondTitle) {
            ariaLabelParts.push(`Subtitle is ${secondTitle}`);
          }
          if (bannerText) {
            ariaLabelParts.push(`Description is ${bannerText}`);
          }
    
          // Set aria-label attribute if any part of the label exists
          if (ariaLabelParts.length > 0) {
            banner.setAttribute('aria-label', ariaLabelParts.join(', '));
          }
      });
    });
    
  
  
    document.addEventListener('DOMContentLoaded', function() { 
      var textbanners = document.querySelectorAll('.text-section-main .content_wrapper');
      
      textbanners.forEach(function(banner) {
        var bannerTitle = banner.querySelector('.heading-wrapper .heading')?.textContent || '';
        var secondTitle = banner.querySelector('.subheading')?.textContent || '';
        var bannerText = banner.querySelector('.description p')?.textContent || '';
    
        // Build aria-label dynamically if content is available
        var ariaLabelParts = [];
        
        if (bannerTitle) {
          ariaLabelParts.push(`Title is ${bannerTitle}`);
        }
        if (secondTitle) {
          ariaLabelParts.push(`Subtitle is ${secondTitle}`);
        }
        if (bannerText) {
          ariaLabelParts.push(`Description is ${bannerText}`);
        }
    
        // Set aria-label if any part is available
        if (ariaLabelParts.length > 0) {
          banner.setAttribute('aria-label', ariaLabelParts.join(', '));
        }
    
        // Check if there are more than 2 paragraphs in the description
        var bannerNum = banner.querySelectorAll('.description p');
        if (bannerNum.length > 2) {
          banner.removeAttribute('aria-label');
          banner.removeAttribute('tabindex');
  
          var description = banner.querySelector('.description');
          description.setAttribute('tabindex','0')
          description.setAttribute('aria-live' , 'polite');
        }
      });
    });  
  
  document.addEventListener('DOMContentLoaded', function() {
    // Select all Swiper pagination elements
    const paginationElements = document.querySelectorAll('.swiper-pagination-bullet');
  
    // Iterate over each pagination element
    paginationElements.forEach(element => {
      // Remove the aria-label attribute
      element.removeAttribute('aria-label');
      // Set tabindex to -1
      element.setAttribute('tabindex', '-1');
    });
  });
  
  document.addEventListener('DOMContentLoaded', function () {
    const detailsElement = document.querySelector('.plp-page-otp');
    const summaryElement = document.querySelector('.plp-page-otp-sum');
  
    function updateAriaLabel() {
      if (detailsElement?.hasAttribute('open')) {
        summaryElement.setAttribute('aria-label', 'Close icon');
      } else {
        summaryElement?.setAttribute('aria-label', 'View options');
      }
    }
    updateAriaLabel();
    detailsElement?.addEventListener('toggle', updateAriaLabel);
  
  
    var pdppopupclose = document.querySelectorAll('.product-popup-modal__toggle svg');
    pdppopupclose.forEach(function(el) {
      el.removeAttribute('aria-label');
      el.removeAttribute('tabindex');
    })
  
    const pdppopups = document.querySelectorAll('.product-main.pdp-main .main-product-section');
    // console.log(pdppopups);
    
     pdppopups.forEach(function (pdppopup) {
      var closebtn = document.querySelector('.closezoomin');
      var closesvg = document.querySelector('.closezoomin svg');
       
       if (closebtn && closesvg) {
        closesvg.removeAttribute('tabindex');
        closesvg.removeAttribute('aria-label');
        closebtn.setAttribute('aria-label', 'close zoom in product image');
      } else {
        console.warn('Close button or SVG not found in this section:', pdppopup);
      }
     })
  
  });
  
  document.addEventListener('DOMContentLoaded', function () { 
    const productsizeoptions = document.querySelectorAll('.size-opt');
    productsizeoptions.forEach(function(el) {
      var nextedelement = el.nextElementSibling.textContent;
      el.nextElementSibling.textContent
      if (el?.hasAttribute('checked')) {
        el.setAttribute('aria-label', `${nextedelement} this is selected size option`)
      } else {
        el.setAttribute('aria-label', `${nextedelement}`)
      }
    })
  });
  document.addEventListener('DOMContentLoaded', function () { 
    const productsliders = document.querySelectorAll('.js-product-card-images');
     productsliders.forEach(function (sl) {
      var productslides = sl.querySelectorAll('.swiper-slide');
      if (productslides.length == 1 ) {
        sl.removeAttribute('tabindex');
        sl.removeAttribute('aria-label');
      }
     })
    })
  
    let isKeyboardFocus = false;
    document.addEventListener('keydown', (event) => {
        // Set the flag to true when a key is pressed
        isKeyboardFocus = true;
    });
    document.addEventListener('mousedown', () => {
        // Set the flag to false if a mouse button is pressed
        isKeyboardFocus = false;
    });
    document.addEventListener('focusin', (event) => {
        const focusedElement = event.target;
        if (isKeyboardFocus && focusedElement.matches('button, a, summary, input, [tabindex="0"], [role="button"], [role="link"], [role="menuitem"]')) {
            focusedElement.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'nearest'
            });
        }
    });
    document.addEventListener('focusout', () => {
        // Reset the flag when focus is lost
        isKeyboardFocus = false;
    });
    
   
  document.addEventListener('DOMContentLoaded', function () {
    const productmodule = document.querySelectorAll('.bundle-image-wrapper');
    productmodule.forEach( function (module) {
      const modulehavebutton = module.querySelector('.image-button');
  
      if (modulehavebutton) {
         module.removeAttribute('tabindex');
         module.removeAttribute('role');
         module.removeAttribute('aria-label');
      }
    })
  })
  
  document.addEventListener("DOMContentLoaded", () => {
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === 'childList') {
          const klaviyoForm = document.querySelector('.klaviyo-form');
          if (klaviyoForm) {
           
            if (klaviyoForm.previousElementSibling) {
              klaviyoForm.previousElementSibling.addEventListener('click', () => {
               
                function getNextFocusableElement(currentElement) {
                  let focusableElements = Array.from(
                    document.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])')
                  ).filter(el => el.offsetWidth > 0 && el.offsetHeight > 0); 
  
                  let currentIndex = focusableElements.indexOf(currentElement);
                  let nextElement = focusableElements[currentIndex + 1];
                  return nextElement || focusableElements[0]; 
                }
  
                const newsletterTrigger = document.querySelector('.js-newsletter-form-trigger');
                if (newsletterTrigger) {
                  
                  setTimeout(() => {
                    const nextElement = getNextFocusableElement(newsletterTrigger);
                    if (nextElement) {
                      nextElement.focus();
                      console.log('Focused element:', nextElement);
                    }
                  }, 500); 
                }
              });
            }
            observer.disconnect(); 
          }
        }
      });
    });
  
    observer.observe(document.body, { childList: true, subtree: true });
  });